import { useEffect, useState } from "react";

import { useOutletView } from "@zenith/features/OutletManagement/hooks/useOutletView";
import { OperationsApiService } from "@zenith/services/transactions";

/**
 * The pending balance of the outlets in view, summed on All Outlets. Null
 * until it has loaded, or while the outlets are still loading.
 */
export const usePendingBalance = (): number | null => {
  const { walletIdsForRequests } = useOutletView();
  const [pendingBalance, setPendingBalance] = useState<number | null>(null);
  const walletsKey = walletIdsForRequests.join(",");

  useEffect(() => {
    if (!walletsKey) {
      setPendingBalance(null);
      return;
    }

    let isCurrent = true;
    OperationsApiService.getPendingBalance(walletsKey.split(","))
      .then((response) => {
        if (isCurrent) setPendingBalance(response.data?.pendingBalance ?? null);
      })
      .catch((error) =>
        console.error("Failed to fetch pending balance:", error)
      );

    return () => {
      isCurrent = false;
    };
  }, [walletsKey]);

  return pendingBalance;
};
